export default {
  title: "Worth Listening",
  content: [
    "Meet Nathan - Adoptive Dad (who also happens to be my husband!)",
    "Meet Ben & Emily: Soon-To-Be Adoptive Parents",
    "HOW to understand the unmet needs of children in foster care",
    "HOW to verbalize and process fears associated with adopting children in foster care",
  ],
};
